import { affiliationService } from "app/services/affiliation.service";
import { ReferralLinksStatistics } from "features/affiliation/common/types";
import { LINKS_STATISTIC_TITLE_TO_VALUE } from "features/affiliation/common/constants";

const useReferralLinks = () => {
  const referralLinksQuery = affiliationService.useGetReferralLinksQuery();
  const referralLinks = referralLinksQuery.data;

  const overviewStatistics = [
    ReferralLinksStatistics.TOTAL_CLICKS,
    ReferralLinksStatistics.REFERRED_USERS,
    ReferralLinksStatistics.PAID_USERS,
  ];
  const referralLinksTabStatistics = [
    ReferralLinksStatistics.NUM_OF_LINKS,
    ReferralLinksStatistics.TOTAL_CLICKS,
  ];

  const getStatisticValue = (title: ReferralLinksStatistics) => {
    const valueType = LINKS_STATISTIC_TITLE_TO_VALUE[title];
    if (valueType === "referral_code") return referralLinks?.length;
    return referralLinks?.reduce((sum, link) => sum + link[valueType], 0);
  };

  return {
    referralLinksQuery,
    overviewStatistics,
    referralLinksTabStatistics,
    getStatisticValue,
  };
};

export default useReferralLinks;
